import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryNosDossiers } from "@/strapiQuery/nosDossiers";
import { NosDossiersContent } from "@/components/pages/nosDossiers/NosDossiers";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const nosDossiersPageContentPromise = getStrapiEntity<NosDossiersContent>(
    "nos-dossiers",
    queryNosDossiers
  );

  const [layout, nosDossiersPageContent] = await Promise.all([
    layoutPromise,
    nosDossiersPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      ...nosDossiersPageContent,
      defaultCanonicalRoute: routes.nosDossiers(),
    },
    revalidate: 10,
  };
};

export { NosDossiers as default } from "@/components/pages/nosDossiers/NosDossiers";
